import React from "react";
import { Typography, Card, CardHeader, CardContent, Box } from "@mui/material";

import CENTAvatar from "../CENTAvatar";
import HTMLRenderer from "../../../Common/Html/HTMLRenderer";
import RenderDate from "../../../Common/Date/RenderDate";

const NotificationCard = ({ notification }) => {
    return (
        <Card className="card">
            <CardHeader
                disableTypography={true}
                avatar={<CENTAvatar type="notification" />}
                title={
                    <Typography component="h2" className="card-header-title">
                        {notification?.title}
                    </Typography>
                }
                subheader={
                    <Typography
                        component="span"
                        className="card-header-subtitle"
                    >
                        {!!notification?.createdAt && (
                            <RenderDate date={notification.createdAt} />
                        )}
                    </Typography>
                }
            />

            <CardContent>
                <Box className="card-content">
                    <HTMLRenderer html={notification?.message ?? ""} />
                </Box>
            </CardContent>
        </Card>
    );
};

export default NotificationCard;
